import Image from "next/image";
import IMAGES from "../../../../../images/importImages";
import { IToggleProps } from "interfaces";
import dynamic from "next/dynamic";

const CloseIcon = dynamic(() => import("../../icon-components/closeIcon"));

const Toggle = ({ enabled, setEnabled }: IToggleProps) => {
    return (
        <div
            className={`pl-relative pl-h-[22px] pl-w-[37px] pl-cursor-pointer pl-rounded-[15px] pl-transition-colors pl-duration-150 pl-ease-linear ${
                enabled ? "pl-bg-main-light hover:pl-bg-main-700" : "pl-bg-secondary-300 hover:!pl-bg-secondary-400"
            }`}
            onClick={setEnabled}
        >
            <div
                className={`pl-absolute pl-left-1 pl-top-[3px] pl-w-[16px] pl-h-[16px] pl-bg-white pl-rounded-full pl-transition-transform pl-duration-150 pl-ease-linear ${
                    enabled ? "pl-translate-x-[13px]" : "pl-translate-x-0"
                }`}
            >
                <div className={`${enabled ? "!pl-mt-[-1px] !pl-mr-[3px]" : "!pl-mt-[-2px] !pl-mr-[4px]"}`}>
                    {enabled ? (
                        <Image src={IMAGES.purpleTick} width={10} height={10} />
                    ) : (
                        <CloseIcon className="pl-w-3 pl-h-3 pl-mx-auto pl-mt-1 pl-mr-[-1px] pl-stroke-secondary-400" />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Toggle;
